//@import services
import UserService from 'app_services/user/userService'
import { store } from 'app_storage/redux-storage'
import React from 'react'
import { ReactChild } from 'react'
import { FaBlackTie, FaBriefcase, FaChalkboardTeacher, FaGraduationCap, FaRegBuilding, FaRegFileExcel, FaUserLock, FaUserGraduate } from 'react-icons/fa'
import { customs } from 'app_config/globals';
import { IoMdHelpCircleOutline } from 'react-icons/io'
import { routingService } from 'app_services/routingService'
//@end

export interface ISidebarMenu {
  id: string,
  class_name: string,
  translation: string,
  icon?: string,
  icon_size?: string
  url: string,
  component?: ReactChild
  disabled?: boolean
  newTab?: boolean
  description?: string
  show?: boolean
}

class SidebarService {

  private userService: UserService
  private storeObject = store

  constructor() {
    this.userService = new UserService()
  }


  getSidebarMenuByUser = () => {

    // const user = this.storeObject.getState().auth?.user
    // let home = null
    // if (user && user.data && user.data.home) {
    //   home = user.data.home.name
    // }

    let menu: ISidebarMenu[] = []
    const roles = this.storeObject.getState()?.auth?.user?.data?.roles
    const currentRoleId = roles?.length
      ? roles[0]._id
      : ''
    if (this.userService.can('permission:jira_menu_access', 'module:jira')) {
      let item: ISidebarMenu = {
        id: 'menu-jira',
        show: false,
        class_name: 'menu-jira',
        translation: 'sidebar.admin.jira',
        // component: <FaJira color='white' size='2rem' className='animation-twinkle' />,
        component: <IoMdHelpCircleOutline color='white' size='2rem' className='animation-twinkle' />,
        url: customs.jira,
        newTab: true,
      }
      menu.push(item)
    }
    if (this.userService.can('permission:profile_menu_access', 'module:profile')) {
      let item: ISidebarMenu = {
        id: 'menu-profile',
        show: true,
        class_name: 'menu-landing',
        translation: 'sidebar.admin.profile',
        icon: 'Profile',
        url: '/',
      }
      menu.push(item)
    }

    if (this.userService.can('permission:course_scheduling_menu_access', 'module:course_scheduling')) {
      let item: ISidebarMenu = {
        id: 'menu-admin-course-scheduling',
        show: true,
        class_name: 'menu-admin-course-scheduling',
        translation: 'sidebar.admin.course_scheduling',
        icon: 'Programming',
        icon_size: '27px',
        url: '/admin/course-scheduling',
      }
      menu.push(item)
    }

    if (this.userService.can('permission:certificate_criteria_menu_access', 'module:certificate_criteria')) {
      let item: ISidebarMenu = {
        id: 'menu-admin-certificate-criteria',
        show: false,
        class_name: 'menu-admin-certificate-criteria',
        translation: 'sidebar.admin.certificate_criteria',
        icon: 'Filter',
        icon_size: '27px',
        url: '/admin/certificate-criteria',
      }
      menu.push(item)
    }

    if (this.userService.can('permission:courses_menu_access', 'module:courses')) {
      let item: ISidebarMenu = {
        id: 'menu-admin-courses',
        show: false,
        class_name: 'menu-admin-courses',
        translation: 'sidebar.admin.course',
        icon: 'Book',
        url: '/admin/courses',
      }
      menu.push(item)
    }

    if (this.userService.can('permission:posts_menu_access', 'module:posts')) {
      let item: ISidebarMenu = {
        id: 'menu-admin-post',
        show: false,
        class_name: 'menu-admin-post',
        translation: 'sidebar.admin.post',
        icon: 'Posts',
        url: '/admin/posts',
      }
      menu.push(item)
    }

    if (this.userService.can('permission:publications_menu_access', 'module:publications')) {
      let item: ISidebarMenu = {
        id: 'menu-admin-publications',
        show: false,
        class_name: 'menu-admin-publications',
        translation: 'sidebar.admin.publications',
        icon: 'Publications',
        url: 'https://tienda.icontec.org/publicaciones.html?product_list_order=products_edition',
        newTab: true,
      }
      menu.push(item)
    }

    if (this.userService.can('permission:banners_menu_access', 'module:banners')) {
      let item: ISidebarMenu = {
        id: 'menu-admin-banner',
        show: false,
        class_name: 'menu-admin-banner',
        translation: 'sidebar.admin.banner',
        icon: 'Banners',
        icon_size: '25',
        url: '/admin/banners',
      }
      menu.push(item)
    }
    if (this.userService.can('permission:forums_menu_access', 'module:forums')) {
      let item: ISidebarMenu = {
        id: 'menu-admin-forum',
        show: false,
        class_name: 'menu-admin-forum',
        translation: 'sidebar.admin.forum',
        icon: 'Forums',
        url: '/admin/forums',
      }
      menu.push(item)
    }
    if (this.userService.can('permission:roles_menu_access', 'module:roles')) {
      let item: ISidebarMenu = {
        id: 'menu-admin-rol',
        show: true,
        class_name: 'menu-admin-rol',
        translation: 'sidebar.admin.rol',
        component: <FaUserLock color='white' size='2rem' />,
        url: '/admin/roles',
      }
      menu.push(item)
    }
    if (this.userService.can('permission:users_menu_access', 'module:users')) {
      let item: ISidebarMenu = {
        id: 'menu-admin-user',
        show: true,
        class_name: 'menu-admin-user',
        translation: 'sidebar.admin.user',
        icon: 'User',
        url: '/admin/users',
      }
      menu.push(item)
    }
    if (this.userService.can('permission:qualifiedTeacher_menu_access', 'module:qualifiedTeacher')) {
      let item: ISidebarMenu = {
        id: 'menu-admin-qualifiedTeacher',
        show: true,
        class_name: 'menu-admin-qualifiedTeacher',
        translation: 'sidebar.admin.qualifiedTeacher',
        component: <FaChalkboardTeacher color='white' size='2rem' />,
        url: '/admin/qualifiedTeacher',
      }
      menu.push(item)
    }
    if (this.userService.can('permission:student_administrator_menu_access', 'module:student_administrator')) {
      let item: ISidebarMenu = {
        id: 'menu-student_administrator',
        show: true,
        class_name: 'menu-student_administrator',
        translation: 'sidebar.admin.student_administrator',
        component: <FaGraduationCap color='white' size='2rem' />,
        url: '/admin/student-administrator',
        disabled: false,
      }
      menu.push(item)
    }
    if (this.userService.can('permission:reports_menu_access', 'module:reports')) {
      let item: ISidebarMenu = {
        id: 'menu-reports',
        show: false,
        class_name: 'menu-reports',
        translation: 'sidebar.admin.reports',
        component: <FaRegFileExcel color='white' size='2rem' />,
        url: '/admin/reports',
        disabled: false,
      }
      menu.push(item)
    }
    if (this.userService.can('permission:account_executives_menu_access', 'module:account_executives')) {
      let item: ISidebarMenu = {
        id: 'menu-admin-account-executive',
        show: true,
        class_name: 'menu-admin-account-executive',
        translation: 'sidebar.admin.account_executive',
        component: <FaBlackTie color='white' size='1.5rem' />,
        url: '/admin/account-executive',
      }
      menu.push(item)
    }
    if (this.userService.can('permission:students_menu_access', 'module:students')) {
      let item: ISidebarMenu = {
        id: 'menu-admin-students',
        show: true,
        class_name: 'menu-admin-students',
        translation: 'sidebar.admin.students',
        component: <FaUserGraduate color='white' size='1.5rem' />,
        url: '/admin/students',
      }
      menu.push(item)
    }
    if (this.userService.can('permission:companies_menu_access', 'module:companies')) {
      let item: ISidebarMenu = {
        id: 'menu-admin-company',
        show: true,
        class_name: 'menu-admin-company',
        translation: 'sidebar.admin.company',
        component: <FaRegBuilding color='white' size='1.5rem' />,
        url: '/admin/companies',
      }
      menu.push(item)
    }
    if (this.userService.can('permission:company_collaborator_access', 'module:company_collaborator')) {
      let item: ISidebarMenu = {
        id: 'menu-admin-company-collaborator',
        show: true,
        class_name: 'menu-admin-company-collaborator',
        translation: 'sidebar.admin.company_collaborator',
        component: <FaBriefcase color='white' size='1.5rem' />,
        url: '/admin/company-collaborator',
      }
      menu.push(item)
    }
    if (this.userService.can('permission:modular_menu_access', 'module:modular')) {
      let item: ISidebarMenu = {
        id: 'menu-admin-modular',
        show: false,
        class_name: 'menu-admin-modular',
        translation: 'sidebar.admin.modular',
        icon: 'Modular',
        url: '/admin/modulars',
      }
      menu.push(item)
    }

    if (this.userService.can('permission:portfolio_menu_access', 'module:portfolio')) {
      let item: ISidebarMenu = {
        id: 'menu-admin-portfolio',
        show: false,
        class_name: 'menu-admin-portfolio',
        translation: 'sidebar.admin.portfolio',
        icon: 'Book',
        url: '/admin/portfolio',
      }
      menu.push(item)
    }

    if (this.userService.can('permission:survey_menu_access', 'module:survey')) {
      let item: ISidebarMenu = {
        id: 'menu-survey',
        show: false,
        class_name: 'menu-survey',
        translation: 'sidebar.admin.survey',
        icon: 'Editor',
        url: '/survey-list',
      }
      menu.push(item)
    }

    if (this.userService.can('permission:landings_menu_access', 'module:landings')) {
      let item: ISidebarMenu = {
        id: 'menu-landing',
        show: false,
        class_name: 'menu-landing',
        translation: 'sidebar.admin.landing',
        icon: 'Edit',
        url: '/admin/landings',
      }
      menu.push(item)
    }
    if (this.userService.can('permission:teaching_resources_menu_access', 'module:teaching_resources')) {
      let item: ISidebarMenu = {
        id: 'menu-teaching_resources',
        show: false,
        class_name: 'menu-teaching_resources',
        translation: 'sidebar.admin.teaching_resources',
        icon: 'TeachingResources',
        url: '/',
        disabled: true,
      }
      menu.push(item)
    }
    if (this.userService.can('permission:isolution_menu_access', 'module:isolution')) {
      let item: ISidebarMenu = {
        id: 'menu-isolution',
        show: false,
        class_name: 'menu-isolution',
        translation: 'sidebar.admin.isolution',
        icon: 'ISolucion',
        url: 'https://sts.icontec.org/adfs/ls/?wtrealm=https%3A%2F%2Fsigo.icontec.org%2FIsolucionV4%2FPaginaLogin.aspx&wctx=WsFedOwinState%3DUyBJUnXn8LGHLglYhwWbBnqo25-sL-l5nLnX-CCNfjn66IdjAzVYFZD0LTZ2LVpxntA2UOvf9IXzfB8Xvn6VnjArNnySBtj_IHrrnWNy_Ta0sITZu0dxsPk_S67gXdAi0pm_4PzyF7JpRiWVxgdftTwm6EI&wa=wsignin1.0&wreply=https%3A%2F%2Fsigo.icontec.org%2FIsolucionV4%2FPaginaLogin.aspx',
        newTab: true,
      }
      menu.push(item)
    }
    if (this.userService.can('permission:consultation_room_menu_access', 'module:consultation_room')) {
      let item: ISidebarMenu = {
        id: 'menu-consultation_room',
        show: false,
        class_name: 'menu-consultation_room',
        translation: 'sidebar.admin.consultation_room',
        icon: 'ConsultationRoom',
        url: 'https://tienda.icontec.org/sala-de-consulta',
        newTab: true,
        description: '(Normas y Publicaciones)*',
      }
      menu.push(item)
    }
    if (this.userService.can('permission:tutorials_menu_access', 'module:tutorials')) {
      let item: ISidebarMenu = {
        id: 'menu-tutorials',
        show: false,
        class_name: 'menu-tutorials',
        translation: 'sidebar.admin.tutorials',
        icon: 'Tutorials',
        url: routingService.getSecurePath(`/tutorials${currentRoleId?.length ? `?defaultValue=${currentRoleId}` : ''}`),
        newTab: true,
      }
      menu.push(item)
    }
    return menu
  }

}

export default SidebarService
